import "./style.scss";

import { Tooltip } from "@mui/material";
import type { CSSProperties } from "react";
import { useRef, useState } from "react";

interface ITextButton {
    text: string;
    handleClick: (e: any) => void;
    underlineOnHover?: boolean;
    style?: CSSProperties;
    disabled?: boolean;
    colorOnHover?: string;
    icon?: JSX.Element;
    iconOnHover?: JSX.Element;
    tooltipText?: string;
}

const TextButton = ({
    text,
    handleClick,
    underlineOnHover = false,
    style,
    disabled,
    colorOnHover,
    icon,
    iconOnHover,
    tooltipText,
}: ITextButton) => {
    const [isHovering, setIsHovering] = useState(false);

    const buttonColor = isHovering && colorOnHover ? colorOnHover : style && style?.color ? style.color : "#275ab0";

    return (
        <Tooltip title={tooltipText ?? ""} arrow>
            <button
                className={`text-button ${underlineOnHover ? "underline" : ""}`}
                onClick={handleClick}
                style={{ ...style, color: buttonColor }}
                disabled={disabled}
                type="button"
                onMouseEnter={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
            >
                {" "}
                {isHovering && iconOnHover ? iconOnHover : icon}
                {text}
            </button>
        </Tooltip>
    );
};

export default TextButton;
